(ns app.front.view.group.admin.inspections.pdf-template-editor
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.inspection.templates-config :as ins-templates-config]
            [app.domain.template.model :as template-model]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.components :as uic]
            [app.front.ui.select :as ui-select]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.inspections.templates-common :as i-templates-common]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.front.view.group.admin.verdict-template.edit :as verdict-template-edit]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-defaults
  (fn [_ [_ group-id]]
    {:comm/command {:command    :inspection/default-template-content
                    :method     :get
                    :data       (util/mmap group-id)
                    :on-success [::fetch-defaults.success]}}))

(rf/reg-event-db ::fetch-defaults.success
  (fn [db [_ _ resp]]
    (assoc db ::defaults resp)))


(defmulti html-editor-data (fn [key _ _ _] key))


(defmethod html-editor-data :title
  [_ tr type _]
  (tr [type]))


(defmethod html-editor-data :placeholders
  [_ _ type permit-type]
  (let [feature-flags (<sub [::ff/enabled-flags])]
    (->> (get-in (ins-templates-config/pdf-template-configs (<sub [::gas/group]) feature-flags)
                 (conj [type] :template-variables))
         (#(template-model/filter-unit-placeholders % feature-flags))
         (map :variable-name)
         ;; Remove work order / inspection variable variants
         (#(if (= :permit-type/PWO permit-type)
             (set/difference (set %) ins-templates-config/inspection-report-inspection-variables)
             (set/difference (set %) ins-templates-config/inspection-report-work-order-variables)))
         ;; Remove licence inspection report template variables, when not licence.
         (#(if (= :permit-type/L permit-type)
             %
             (set/difference (set %) ins-templates-config/inspection-report-licence-template-variables))))))


(defmethod html-editor-data :snippets
  [_ _ type _]
  (->> (get-in (ins-templates-config/pdf-template-configs (<sub [::gas/group])
                                                          (<sub [::ff/enabled-flags]))
               [type :snippets])
       (remove :hide-html-editor?)))


;;; Events
;;;;;;;;;;

(defn clear-cache
  [db]
  (dissoc db ::temp-pdf-template))

(rf/reg-event-db ::set-temp-pdf-template
  (fn [db [_ template]]
    (-> db
        (assoc ::temp-pdf-template (into {} template))
        (assoc-in [::temp-pdf-template :db/id] (:db/id template)))))


(rf/reg-event-db ::set-pdf-template-value
  (i-templates-common/set-value-fn ::temp-pdf-template))


(rf/reg-event-fx ::save-pdf-template-value
  (i-templates-common/save-value-handler-fn :inspection/edit-pdf-template))


(defn set-and-save [id values & [extra-args]]
  (>evt [::set-pdf-template-value id values])
  (when (some? id)
    (>evt [::save-pdf-template-value id values extra-args])))


(rf/reg-event-fx ::save-new-pdf-template
  (i-templates-common/save-handler-fn :inspection/create-new-pdf-template
                                      :group-id
                                      inspection-model/pdf-template-editable-keys
                                      ::save-new-done-pdf-template))


(rf/reg-event-fx ::save-new-done-pdf-template
  (fn [ctx [_ _ changes :as event]]
    (let [template-id (-> (p/find-first changes #(-> % val :inspection.pdf-template/type))
                          first)
          group-id    (get-in changes [template-id :domain/authority-group 1])]
      (-> ((i-templates-common/save-done-handler-fn ::temp-pdf-template) ctx event)
          (assoc :route/push {:route  :view/group.admin.template
                              :params {:group-id    group-id
                                       :template-id template-id}})))))


(rf/reg-event-fx ::delete-pdf-template
  (i-templates-common/delete-entity :inspection/delete-pdf-template))


(rf/reg-event-fx ::copy-pdf-template
  (fn [_ [_ group-id copied-template]]
    {:dispatch [::save-new-pdf-template
                group-id
                (-> (into {} copied-template)
                    (assoc :inspection.pdf-template/active? false)
                    (update :inspection.pdf-template/name str " (copy)"))]}))


;;; Subscriptions
;;;;;;;;;;;;;;;;;


;; The pdf template that is currently being edited
(rf/reg-sub ::temp-pdf-template-raw
  (fn [{::keys [temp-pdf-template]} _]
    temp-pdf-template))

(rf/reg-sub ::defaults
  :-> ::defaults)

(rf/reg-sub ::temp-pdf-template
  :<- [::temp-pdf-template-raw]
  :<- [::defaults]
  (fn [[temp-pdf-template defaults] _]
    (let [type (:inspection.pdf-template/type temp-pdf-template)]
      (merge (get defaults type)
             temp-pdf-template))))

(rf/reg-sub ::save-new-pdf-template-disabled?
  :<- [::temp-pdf-template]
  (fn [{:inspection.pdf-template/keys [name type]}]
    (or (str/blank? name) (str/blank? type))))

;;; Components
;;;;;;;;;;;;;;


(def simple-editor-for-pdf-template
  (partial i-templates-common/simple-editor {:set-value-event  ::set-pdf-template-value
                                             :save-value-event ::save-pdf-template-value}))

(defn html-editor [tr inherited? {:inspection.pdf-template/keys [html-template print-css type] :as item} id group-id]
  (let [permit-type (<sub [::gas/group-primary-permit-type])
        snippets    (html-editor-data :snippets tr type permit-type)]
    [:<>
     [template-editor/editor
      (-> {:html-template         html-template
           :read-only?            inherited?
           :print-css             print-css
           :tr                    tr
           :on-save               (fn [html css]
                                    (set-and-save id [[:inspection.pdf-template/html-template html]
                                                      [:inspection.pdf-template/print-css css]]))
           :title                 [:h3 (html-editor-data :title tr type permit-type)]
           :placeholders          (html-editor-data :placeholders tr type permit-type)
           :valid-placeholder-ids (keep :template-reference snippets)
           :images                (<sub [::gas/verdict-images group-id])}
          (util/assoc-when :preview-url (when id
                                          (file-download/download-href
                                            :group/generate-ins-template-preview-pdf
                                            {:group-id    group-id
                                             :template-id id})))
          (text-editor/with-external-edit-state ::main-template))
      (for-frag [config-for-snippet snippets]
        (document-editor/editor-for-snippet config-for-snippet
                                            (util/mmap {:document-id     (:db/id item)
                                                        :read-only?      inherited?
                                                        :save-db-snippet (comp (partial set-and-save id) vector)
                                                        :get-db-snippet  (partial get item)}
                                                       tr group-id)))]]))


(defn pdf-template-editor [tr group-id inherited?]
  (let [{:db/keys [id] :as item} (<sub [::temp-pdf-template])
        group                    (<sub [::gas/group])
        ctx                      (util/mmap {:disabled (boolean inherited?)} item tr id)
        pdf-template-type        (:inspection.pdf-template/type item)
        template-types           (ins-templates-config/available-pdf-template-types-for-group group)]
    [:<>
     [uic/form-field-wide
      [simple-editor-for-pdf-template ctx ui/text-input :inspection.pdf-template/name]]
     [uic/form-field-wide
      [ui-select/select
       {:values       template-types
        :id           "pdf-type-select"
        :class-name   "admin-pdf-type-select"
        :label-text   (tr [:inspection.pdf-template/type])
        :val->str     #(tr [%])
        :on-change    #(set-and-save nil [[:inspection.pdf-template/type %]])
        :value        pdf-template-type
        :disabled     (or (boolean id) inherited?)
        :required     true
        :allow-empty? false}]]
     [uic/form-field-wide
      (cc/toggle {:id         "enable-template-toggle"
                  :label-text (tr [:inspection.pdf-template/enable-template])
                  :toggled    (if inherited?
                                (-> (<sub [::gas/group-inherited-template-ids]) (contains? id))
                                (boolean (:inspection.pdf-template/active? item)))
                  :on-toggle  (fn [val]
                                (if inherited?
                                  (>evt [::verdict-template-edit/set-inherited-available group-id id val])
                                  (set-and-save id
                                                [[:inspection.pdf-template/active? val]]
                                                {:notify (if val
                                                           {:success :inspection.pdf-template/template-activated}
                                                           {:success :inspection.pdf-template/template-deactivated})})))})]
     (when id
       [uic/form-field-wide
        (html-editor tr inherited? item id group-id)])
     (when (nil? id)
       [uic/form-field-wide
        (cc/button
          {:icon             i/save
           :icon-description (tr [:create])
           :on-click         #(>evt [::save-new-pdf-template group-id item])
           :disabled         (<sub [::save-new-pdf-template-disabled?])}
          (tr [:create]))])]))


(defn view [tr group-id template inherited?]
  (let [template-id (:db/id template)
        current-id  (:db/id (<sub [::temp-pdf-template]))]
    (when (not= template-id current-id)
      (>evt [::set-temp-pdf-template (p/assoc-if (into {} template) :db/id template-id)]))
    [acommon/section {:title (if (nil? template-id)
                               (tr [:template-editor/add-new-pdf-template])
                               (:inspection.pdf-template/name template))}
     [pdf-template-editor tr group-id inherited?]]))
